"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Language = void 0;
var Language = /** @class */ (function () {
    function Language(data) {
        this.system = data.system;
    }
    return Language;
}());
exports.Language = Language;
//# sourceMappingURL=language-models.js.map